import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login_box" }
const _hoisted_2 = { class: "login_content" }
const _hoisted_3 = { class: "content_box" }
const _hoisted_4 = { class: "login_wrap_left" }
const _hoisted_5 = { class: "swiper_box" }
const _hoisted_6 = { class: "login_wrap_right" }
const _hoisted_7 = { class: "right_conteng" }
const _hoisted_8 = {
  key: 0,
  class: "wrap_form"
}
const _hoisted_9 = { class: "wrap_form_top" }
const _hoisted_10 = { class: "form_item" }
const _hoisted_11 = { class: "wrap_form_center" }
const _hoisted_12 = { class: "form_top" }
const _hoisted_13 = { class: "wrap_form_bottom" }
const _hoisted_14 = { class: "form_bottom" }
const _hoisted_15 = { class: "wrap_form_btn" }
const _hoisted_16 = { class: "wrap_button" }
const _hoisted_17 = { class: "agreement_check" }
const _hoisted_18 = { class: "wrap_active_visible" }
const _hoisted_19 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rotation = _resolveComponent("Rotation")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_PrivacyPolicy = _resolveComponent("PrivacyPolicy")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Rotation)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("h2", null, "注册账号", -1)),
            (_ctx.isShowform)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_input, {
                        class: "form_item_name",
                        value: _ctx.formData.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                        placeholder: "请输入用户名",
                        onPressEnter: _ctx.rules,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = _ctx.formData.name.replace(/[^\u4e00-\u9fa5_a-zA-Z0-9]+/g, ''))),
                        onBlur: _ctx.rules
                      }, null, 8, ["value", "onPressEnter", "onBlur"])
                    ]),
                    _withDirectives(_createVNode(_component_CheckOutlined, { class: "wrap_form_top_icon" }, null, 512), [
                      [_vShow, _ctx.showYes]
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "wrap_form_top_name",
                    style: _normalizeStyle({ color: _ctx.nameText ? '#ff4d4f' : '#9aa1a9' })
                  }, _toDisplayString(_ctx.nameText ? _ctx.nameText : '6~18位字符，只能包含中文、英文字母、数字、下划线。'), 5),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_input, {
                        class: "form_top_name",
                        value: _ctx.formData.username,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.username) = $event)),
                        placeholder: "请输入手机号",
                        onkeyup: "this.value=this.value.replace(/\\s+/g,'')",
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_input, {
                        class: "form_bottom_valid",
                        style: {"font-size":"14px"},
                        value: _ctx.formData.code,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.code) = $event)),
                        placeholder: "请输入验证码",
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createVNode(_component_a_button, {
                        type: "primary",
                        class: "wrap_form_button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCode()))
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" 获取验证码 ", -1)
                        ]))]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.isShowcode]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_ctx.count) + ") ", 513), [
                        [_vShow, !_ctx.isShowcode]
                      ])
                    ])
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "awsc" }, null, -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _cache[11] || (_cache[11] = _createTextVNode("已有账号，去", -1)),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jump())),
                  class: "buttn_p"
                }, "登录")
              ]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.register()))
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("注 册", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_checkbox, {
                  checked: _ctx.agreementCheckbox,
                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agreementCheckbox) = $event))
                }, null, 8, ["checked"]),
                _cache[13] || (_cache[13] = _createTextVNode(" 我已阅读并接受", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/service-agreement",
                  target: "blank"
                }, "服务协议", -1)),
                _cache[15] || (_cache[15] = _createTextVNode("、 ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/privacy",
                  target: "blank"
                }, "隐私政策", -1)),
                _cache[17] || (_cache[17] = _createTextVNode("、 ", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/anchor-specification",
                  target: "blank"
                }, "网络主播行为规范", -1))
              ])
            ])
          ]),
          _createVNode(_component_a_modal, {
            visible: _ctx.visible,
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
            width: "1000px",
            onOk: _ctx.handleOk,
            footer: null,
            centered: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_PrivacyPolicy)
              ])
            ]),
            _: 1
          }, 8, ["visible", "onOk"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.customData
          ? _ctx.customData.copyright
          : 'Copyright © 2022 www.qing.tv All Rights Reserved Powered by Shanghai Bonwey Technology Co., Ltd'), 1)
  ]))
}